import Header from "@/components/app/Header";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-5 md:px-8 pt-10 md:pt-14 pb-20" data-testid="terms-page">
        <div className="overline mb-3">Condizioni</div>
        <h1 className="font-display text-3xl sm:text-4xl font-light text-[#1A231F]">Termini di Servizio</h1>
        <p className="mt-3 text-sm text-[#5C7066]">Ultimo aggiornamento: 26 Febbraio 2026</p>

        <div className="prose prose-sm max-w-none mt-10 text-[#3A4A42] leading-relaxed space-y-6">
          <p>
            I presenti Termini di Servizio ("Termini") regolano l'utilizzo del sistema di prenotazione online disponibile
            su <strong>prenota.lucaderobertis.it</strong> (di seguito "Sito") gestito dal Dott. Luca DeRobertis.
            L'utilizzo del Sito implica l'accettazione integrale dei presenti Termini.
          </p>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">1. Titolare del servizio</h2>
            <p>
              <strong>Dott. Luca DeRobertis</strong>, Osteopata e Fisioterapista
              <br />
              Sede legale: Via Valsolda, Milano
              <br />
              P.IVA: 03232340830
              <br />
              Iscrizione albo FNOFI n. 5427
              <br />
              Email:{" "}
              <a href="mailto:lucaderobertis@gmail.com" className="text-[#2D4A3E] underline">
                lucaderobertis@gmail.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">2. Descrizione del servizio</h2>
            <p>
              Il Sito consente agli utenti di prenotare online sedute di osteopatia e fisioterapia presso gli studi di
              Milano gestiti dal Titolare. Il servizio comprende:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Consultazione degli orari disponibili in tempo reale</li>
              <li>Prenotazione dell'appuntamento nella sede scelta</li>
              <li>Ricezione di email di conferma e promemoria</li>
              <li>Sincronizzazione con il calendario del professionista</li>
            </ul>
            <p className="mt-2">
              Il Sito è un semplice strumento di prenotazione. La prestazione sanitaria vera e propria è erogata in
              presenza presso la sede indicata.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">3. Requisiti di utilizzo</h2>
            <p>
              L'utente dichiara di:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Avere almeno 18 anni oppure essere autorizzato da un genitore o tutore legale</li>
              <li>Fornire dati veritieri, corretti e aggiornati durante la prenotazione</li>
              <li>Utilizzare il servizio esclusivamente per fini leciti e per il proprio uso personale</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">4. Prenotazione, modifiche e cancellazioni</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>La prenotazione si intende confermata al ricevimento dell'email di conferma</li>
              <li>
                Modifiche e cancellazioni sono possibili contattando direttamente il professionista via WhatsApp o
                email con un preavviso minimo di <strong>24 ore</strong>
              </li>
              <li>
                Il Titolare si riserva il diritto di annullare o riprogrammare appuntamenti in caso di forza maggiore,
                dandone tempestiva comunicazione all'utente
              </li>
              <li>
                Ripetuti mancati presentazioni ("no-show") senza preavviso potranno comportare la limitazione
                dell'accesso al servizio di prenotazione online
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">5. Pagamento</h2>
            <p>
              Il pagamento della prestazione avviene direttamente in sede al termine della seduta, secondo le tariffe
              comunicate. Il Sito non gestisce pagamenti online.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">6. Responsabilità</h2>
            <p>
              Il Titolare si impegna a garantire il corretto funzionamento del Sito, ma non può escludere possibili
              interruzioni dovute a manutenzione, cause tecniche o di forza maggiore. In tali casi non sarà responsabile
              di eventuali disservizi indiretti.
            </p>
            <p>
              I contenuti del Sito hanno valore informativo e non sostituiscono in alcun modo il parere di un
              professionista sanitario in sede di visita.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">7. Proprietà intellettuale</h2>
            <p>
              Tutti i contenuti del Sito (testi, immagini, logo, design) sono di proprietà del Titolare o dei rispettivi
              licenziatari e sono protetti dalle leggi vigenti in materia di proprietà intellettuale. Ne è vietata la
              riproduzione, in tutto o in parte, senza autorizzazione scritta.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">8. Trattamento dei dati personali</h2>
            <p>
              Il trattamento dei dati forniti dagli utenti è disciplinato dalla{" "}
              <Link to="/privacy" className="text-[#2D4A3E] underline">
                Informativa sulla Privacy
              </Link>
              , parte integrante dei presenti Termini.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">9. Modifiche ai Termini</h2>
            <p>
              Il Titolare si riserva il diritto di aggiornare i presenti Termini in qualsiasi momento. Eventuali
              modifiche saranno pubblicate su questa pagina con l'indicazione della data di ultimo aggiornamento e
              avranno effetto dal momento della pubblicazione.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">10. Legge applicabile e foro competente</h2>
            <p>
              I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia derivante dall'utilizzo
              del Sito sarà competente in via esclusiva il Foro di Milano, salvo diversa disposizione inderogabile di
              legge per il consumatore.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">11. Contatti</h2>
            <p>
              Per qualsiasi richiesta o chiarimento in merito ai presenti Termini è possibile scrivere a{" "}
              <a href="mailto:lucaderobertis@gmail.com" className="text-[#2D4A3E] underline">
                lucaderobertis@gmail.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-14 pt-6 border-t border-[#2D4A3E]/10 text-sm text-[#5C7066]">
          <Link to="/" data-testid="terms-back-link" className="text-[#2D4A3E] hover:underline">
            ← Torna alla home
          </Link>
        </div>
      </main>
    </div>
  );
}
